<template>
  <section class="preview">
    <form novalidate @submit.prevent="crear">
      
        <div class="form-group">
            <label class="typo__label">Campaña</label>
            <multiselect
            v-model="campaign_id"
            placeholder="Seleccione el País"
            label="name"
            track-by="id"
            :options="campaigns"
            :multiple="false"
            :taggable="false"
            ></multiselect>
        </div>

        <div class="form-group">
            <label class="typo__label">Objetivo de optimizacion</label>
            <multiselect
            v-model="optimization_goal_id"
            placeholder="Objetivo de optimizacion"
            label="name"
            track-by="code"
            :options="optimizationGoals"
            :multiple="false"
            :taggable="false"
            ></multiselect>
        </div>

        <div class="form-group">
            <label class="typo__label">Evento personalizado</label>
            <multiselect
            v-model="custom_event_id"
            placeholder="Evento personalizado"
            label="name"
            track-by="id"
            :options="customEvents"
            :multiple="false"
            :taggable="false"
            ></multiselect>
        </div>


        <div class="form-group">
            <label class="typo__label">Billing Events</label>
            <multiselect
            v-model="billing_event_id"
            placeholder="Seleccione el País"
            label="name"
            track-by="code"
            :options="billingEvents"
            :multiple="false"
            :taggable="false"
            ></multiselect>
        </div>

       
        <div class="form-group">
            <label class="typo__label">Ritmo</label>
            <multiselect
            v-model="pacing_type"
            placeholder="Tipo de ritmo"
            label="name"
            track-by="value"
            :options="pacingTypes"
            :multiple="false"
            :taggable="false"
            ></multiselect>
        </div>

        <mdb-input
            label="Nombre de rol"
            class="mb-3 mt-0"
            v-model="name"
            required
            invalidFeedback="Coloca el nombre"
        ></mdb-input>

        <div class="form-group">
            <label class="typo__label">Estado</label>
            <multiselect
            v-model="status_id"
            placeholder="Seleccione el País"
            label="name"
            track-by="value"
            :options="status"
            :multiple="false"
            :taggable="false"
            ></multiselect>
        </div>

        <div class="form-group">
            <label class="typo__label">Target</label>
            <multiselect
            v-model="targeting_id"
            placeholder="Seleccione el País"
            label="name"
            track-by="id"
            :options="targets"
            :multiple="false"
            :taggable="false"
            ></multiselect>
        </div>

        <div class="form-group">
           <b-form-checkbox
            id="checkbox-1"
            v-model="campaign_dates"
            name="checkbox-1"
          >
            Fecha de campaña
          </b-form-checkbox>
        </div>

        <div class="form-group" v-if="!campaign_dates">
          <label>Fecha inicio</label>
          <datetime type="datetime" input-id="fecha-input" format="yyyy-MM-DD hh:mm:ss" v-model="start_date"></datetime>
        </div>

        <div class="form-group" v-if="!campaign_dates">
          <label>Fecha fin</label>
          <datetime type="datetime" input-id="fecha-input" format="yyyy-MM-DD hh:mm:ss" v-model="end_date"></datetime>
        </div>

        <div class="form-group">
          <b-form-checkbox
            id="checkbox-1"
            v-model="will_be_splited"
            name="checkbox-1"
          >
            Split por estado
          </b-form-checkbox>
        </div>


      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Editar</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>



<script>
import { SemipolarSpinner } from "epic-spinners";
import Multiselect from "vue-multiselect";
import store from "../../store";
import { Datetime } from 'vue-datetime';
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbTooltip
} from "mdbvue";
export default {
  name: "modal-2",
  components: {
    Multiselect,
    Datetime,
    SemipolarSpinner,
    mdbContainer,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput,
    mdbTooltip
  },
  props: {
    onClick: Function,
    adset:Object
  },
  data: () => {
    return {
      id:'',
      isLoading: false,
      is_value_based:false,
      name: "",
      account_id:"",
      account_status:{},
      custom_event_id:{},
      optimization_goal_id:{},
      customEvents:[],
      accounts_status:[
          {name:"ACTIVE",value:"1"},
          {name:"DISABLED",value:"2"},
          {name:"UNSETTLED",value:"3"},
          {name:"PENDING_RISK_REVIEW",value:"7"},
          {name:"PENDING_SETTLEMENT",value:"8"},
          {name:"IN_GRACE_PERIOD",value:"9"},
          {name:"PENDING_CLOSURE",value:"100"},
          {name:"CLOSED",value:"101"},
          {name:"ANY_ACTIVE",value:"201"},
          {name:"ANY_CLOSED",value:"202"},
      ],
      bidStrategys: [
        { name: "Menor costo sin límite", value: "LOWEST_COST_WITHOUT_CAP" },
        { name: "Menor costo con límite", value: "LOWEST_COST_WITH_BID_CAP"},
        { name: "Costo por objetivo", value:"TARGET_COST" }
      ],
      pacingTypes: [
        { name: "Standard", value: "standard" },
        { name: "Day parting", value: "day_parting" },
        { name: "No pacing", value: "no_pacing" },
        { name: "Disabled", value: "disabled" }
      ],
      status: [
        { name: "Activa", value: "ACTIVE" },
        { name: "Pausada", value: "PAUSED" },
        { name: "Eliminada", value: "DELETED" },
        { name: "Archivada", value: "ARCHIVED" }
      ],
      campaign_id:{},
      billing_even:{},
      campaigns:[],
      optimizationGoals:[],
      billing_event_id:{},
      pacing_type:{},
      billingEvents:[],
      status_id:{},
      targets:[],
      targeting_id:{},
      state:"draft",
      will_be_splited:false,
      pacing_start_minute: 0,
      pacing_end_minute: 0,
      start_date:"",
      end_date:"",
      campaign_dates: false
    };
  },
  async mounted() {
    const { adset } = this;
    this.id = adset.id;
    this.bid_amount = adset.bid_amount;
    this.status_id = {id:adset.status};
    this.will_be_splited = adset.will_be_splited;
    this.campaign_id = adset.campaign_id;
    this.optimization_goal_id = adset.optimization_goal_id;
    this.billing_event_id = adset.billing_event_id;
    this.name = adset.name;
    this.targeting_id = adset.targeting_id;
    this.start_date = adset.start_date;
    this.end_date = adset.end_date;
    this.campaign_dates = adset.campaign_dates;
    this.custom_event_id = adset.custom_event_id;

    await this.getBillingEvents()
    await this.getCustomEvents();
    await this.getCampaigns()
    await this.getOptimizationGoal()
    await this.getTargets()
    
    
  },
  methods: {
    async getCampaigns(){
        var campaigns = store.getters.getCampaigns;
        if (campaigns.length == 0) {
            await store.dispatch("getCampaigns").then(() => {
            var campaigns = store.getters.getCampaigns;
            this.campaigns = campaigns;
            });
        } else {
            this.campaigns = campaigns;
        }
    },
    async getOptimizationGoal(){

     

      var optimizationGoals = store.getters.getOptimizationGoal;
      if (optimizationGoals.length == 0) {
      
        await store.dispatch("getOptimizationGoal").then(() => {
          optimizationGoals = store.getters.getOptimizationGoal;
          this.optimizationGoals = optimizationGoals;
          return;
        });
      } else {
        this.optimizationGoals = optimizationGoals;
        return;
      }
    },
    async getCustomEvents(){
      var customEvents = store.getters.getCustomEvents;
      if (customEvents.length == 0) {
        await store.dispatch("getCustomEvents").then(() => {
          customEvents = store.getters.getCustomEvents;
          this.customEvents = customEvents;
          return;
        });
      } else {
        this.customEvents = customEvents;
        return;
      }
    },
    async getBillingEvents(){
      await store.dispatch("getBillingEvents").then(() => {
        var billingEvents = store.getters.getBillingEvents;
        this.billingEvents = billingEvents;
        return;
      });
     
    },
    async getTargets(){
      var targets = store.getters.getStereotypes;
      if (targets.length == 0) {
        await store.dispatch("getStereotypes").then(() => {
          targets = store.getters.getStereotypes;
          this.targets = targets;
          return;
        });
      } else {
        this.targets = targets;
        return;
      }
    },
    crear(event) {
      event.target.classList.add("was-validated");
      var { 
        id,
        state,
        pacing_type,
        status_id,//este debe enviarse como status
        will_be_splited,
        campaign_id,
        billing_event_id,
        pacing_start_minute,
        pacing_end_minute,
        name,
        targeting_id,
        start_date,
        end_date,
        campaign_dates,
        optimization_goal_id,
        custom_event_id
      } = this;
      this.isLoading = true;
      if (
          name == "" ||
          pacing_type == {} ||
          status_id == {} ||
          optimization_goal_id == {} ||
          campaign_id == {} ||
          billing_event_id == {} ||
          targeting_id == {} 
          ) {
        this.isLoading = false;
      } else {
        var adset = {
          id,
          state_id:state,
          pacing_type,
          status: status_id,
          will_be_splited,
          campaign_id,
          billing_event_id,
          pacing_start_minute,
          pacing_end_minute,
          name,
          targeting_id,
          start_date,
          end_date,
          campaign_dates,
          custom_event_id,
          optimization_goal_id
        };
        store.dispatch("editAdsets", adset).then(() => {
          this.name=""
          this.onClick();
          this.isLoading = false;
        });
      }
    },
    
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
input#fecha-input {
    width: 100%;
    height: 40px;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 10px;
}
</style>